"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_table_1 = require("react-table");
var tables_styles_1 = require("./tables.styles");
var sortingArrow_icon_1 = require("../../icons/arrow/sortingArrow.icon");
var analyticsService_1 = require("../../analytics/analyticsService");
exports.Table = function (props) {
    var defaultColumn = react_1.default.useMemo(function () { return ({
        // When using the useFlexLayout:
        minWidth: 1,
        width: 2,
    }); }, []);
    react_1.useEffect(function () {
        setPageSize(props.pageSize);
    }, [props.pageSize]);
    var _a = react_table_1.useTable({
        columns: props.columns,
        data: props.data,
        defaultColumn: defaultColumn,
        disableSortRemove: true,
        maxMultiSortColCount: 2,
        initialState: {
            // @ts-ignore
            pageIndex: props.pageIndex,
            pageSize: props.pageSize,
            sortBy: [{ id: props.sortBy, desc: props.desc }],
        },
    }, react_table_1.useSortBy, react_table_1.usePagination, react_table_1.useFlexLayout), getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, prepareRow = _a.prepareRow, page = _a.page, canPreviousPage = _a.canPreviousPage, canNextPage = _a.canNextPage, pageOptions = _a.pageOptions, pageCount = _a.pageCount, gotoPage = _a.gotoPage, nextPage = _a.nextPage, previousPage = _a.previousPage, setPageSize = _a.setPageSize, _b = _a.state, pageIndex = _b.pageIndex, pageSize = _b.pageSize, sortBy = _b.sortBy;
    function recordSortEvent() {
        analyticsService_1.AnalyticsService.recordEvent("sort-" + props.id);
    }
    react_1.useEffect(function () {
        recordSortEvent();
    }, [sortBy]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", __assign({}, getTableProps(), { className: tables_styles_1.table, id: props.id }),
            react_1.default.createElement("div", { className: tables_styles_1.thead, "data-qa": "headers" }, headerGroups.map(function (headerGroup) { return (react_1.default.createElement("div", __assign({}, headerGroup.getHeaderGroupProps(), { className: tables_styles_1.trHead, key: headerGroup.index }), headerGroup.headers.map(function (column) { return (react_1.default.createElement("div", __assign({}, column.getHeaderProps(), { key: column.id, className: tables_styles_1.th, id: column.id, "data-qa-header": column.id, width: column.width }), column.hideTitle !== true ? (react_1.default.createElement("span", __assign({ key: column.id }, column.getSortByToggleProps(), { "data-qa": column.isSorted ? "sorted" : "unsorted", "data-qa-direction": column.isSortedDesc ? "up" : "down", className: column.isSorted ? tables_styles_1.sorted : "" }),
                column.render("Header"),
                column.disableSortBy !== true ? (react_1.default.createElement(react_1.default.Fragment, null, column.isSorted ? (column.isSortedDesc ? (react_1.default.createElement(sortingArrow_icon_1.SortingArrowIcon, { direction: 1, active: true })) : (react_1.default.createElement(sortingArrow_icon_1.SortingArrowIcon, { direction: -1, active: true }))) : (react_1.default.createElement(sortingArrow_icon_1.SortingArrowIcon, { direction: -1 })))) : (""))) : (""))); }))); })),
            react_1.default.createElement("div", __assign({}, getTableBodyProps(), { className: tables_styles_1.tbody, "data-qa": "rows" }), page.map(function (row) {
                prepareRow(row);
                return (react_1.default.createElement("div", __assign({ className: tables_styles_1.tr, id: row["original"]["id"] }, row.getRowProps(), { key: row.id, "data-qa": "row" }), row.cells.map(function (cell) {
                    return (react_1.default.createElement("div", __assign({}, cell.getCellProps(), { className: tables_styles_1.td, key: cell.id }), cell.render("Cell")));
                })));
            }))),
        props.hasPagination && (react_1.default.createElement("div", { className: tables_styles_1.pagination },
            react_1.default.createElement("button", { onClick: function () { return gotoPage(0); }, disabled: !canPreviousPage }, "<<"),
            " ",
            react_1.default.createElement("button", { onClick: function () { return previousPage(); }, disabled: !canPreviousPage }, "<"),
            " ",
            react_1.default.createElement("button", { onClick: function () { return nextPage(); }, disabled: !canNextPage }, ">"),
            " ",
            react_1.default.createElement("button", { onClick: function () { return gotoPage(pageCount - 1); }, disabled: !canNextPage }, ">>"),
            " ",
            react_1.default.createElement("span", null,
                "Page",
                " ",
                react_1.default.createElement("strong", null,
                    pageIndex + 1,
                    " of ",
                    pageOptions.length),
                " "),
            react_1.default.createElement("span", null,
                "| Go to page:",
                " ",
                react_1.default.createElement("input", { type: "number", defaultValue: pageIndex + 1, onChange: function (e) {
                        var page = e.target.value ? Number(e.target.value) - 1 : 0;
                        gotoPage(page);
                    }, style: { width: "100px" } })),
            " ",
            react_1.default.createElement("select", { value: pageSize, onChange: function (e) {
                    setPageSize(Number(e.target.value));
                } }, [10, 25, 30, 40, 50].map(function (pageSize) { return (react_1.default.createElement("option", { key: pageSize, value: pageSize },
                "Show ",
                pageSize)); }))))));
};
exports.Table.defaultProps = {
    hasPagination: false,
    pageSize: -1,
    pageIndex: 0,
};
exports.Table.defaultProps = {
    hasPagination: false,
    pageSize: -1,
    pageIndex: 0,
};
